
<template>
  <!--订单审核-->
  <div>
    <!--删除列表时使用的是rowKey的id-->
    <x-tabula
      ref="table"
      rowKey=""
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_name" slot-scope="{row}">
        <div class="product-name">
          <img style="height: 44px;" :src="row.productImg" alt="">
          <span>{{row.productName}}</span>
        </div>
      </template>

      <template slot="opt_status" slot-scope="{row}">
        <div style="display: flex; align-items: center">
          <span class="circle-dot" :class="row.status === 0 ? 'success-bg' : 'danger-bg'"></span>
          <span>{{row.statusDesc}}</span>
        </div>
      </template>
    </x-tabula>

    <!--订单审核的弹窗-->
    <a-modal
      title="审核"
      :visible="visible"
      @cancel="visible=false"
      @ok="$refs.addEdit.handleSubmit()"
      :confirmLoading="btnLoading.loading"
      v-bind="$store.state.modalConfig"
      :width="750"
    >
      <x-addEdit
        ref="addEdit"
        modalType="modal"
        :isSubmitBtn="false"
        :reqLoading="btnLoading"
        :formList="formList"
        :formKey="formKey"
        :addParam="addParam"
        :editParam="editParam"
        :detailParam="detailParam"
      />
    </a-modal>
  </div>
</template>

<script>
const auditStatus = [ // 0审核通过 1审核失败
  { value: 0, label: '未审核' },
  { value: 1, label: '审核失败' }
];
export default {
  name: 'orderAudit',
  data () {
    return {
      visible: false,
      btnLoading: { loading: false },
      formList: [
        {
          label: '审核状态',
          inputType: 'select',
          options: [ // 0审核通过 1审核失败
            { value: 0, label: '审核通过' },
            { value: 1, label: '审核失败' }
          ],
          handle: '',
          placeholder: '请选择审核状态',
          props: ['status', {
            rules: [{required: true, message: '请选择审核状态'}]
          }]
        },
        {
          label: '审核备注',
          inputType: 'textarea',
          options: [],
          handle: '',
          placeholder: '请输入至少5个字符',
          props: ['desc', {
            rules: [{ min: 5, message: '请输入至少5个字符' }]
          }]
        }
      ],
      formKey: {
        status: undefined,
        desc: undefined
      },
      addParam: {
        url: '',
        reqHandle: this.reqHandle, // addParam、editParaM都会执行 reqHandle方法
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/pm/order/checkOrder',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '',
        resHandle: '' // this.detailResHandle
      },

      searchList: [
        { props: ['phone'], placeholder: '账号', options: [], inputType: 'input' },
        { props: ['status'], placeholder: '状态', options: auditStatus, inputType: 'select' },
        { props: ['createTime'], placeholder: ['创建时间', '创建时间'], options: [], inputType: 'datePick' }, // startTime endTime
        { props: ['orderId'], placeholder: '订单ID', options: [], inputType: 'input' }
      ],
      tableOptList: [],
      rowOptList: [
        {
          text: '审核',
          handle: row => this.orderAudit(row), // 处理方法
          rowOptDisHandle: row => row.status === 1, // 禁用按钮
          permi: ['community:orderAudit:audit']
        }
      ],
      columns: [
        { title: '订单创建时间', dataIndex: 'createTime', align: '', width: '' },
        { title: '订单ID', dataIndex: 'orderId', align: '', width: '' },
        { title: '账号', dataIndex: 'phone', align: '', width: '' },
        { title: '商品名称', dataIndex: 'productName', align: '', width: '', scopedSlots: { customRender: 'name' } },
        { title: '兑换价(积分)', dataIndex: 'points', align: '', width: '' },
        { title: '收货信息', dataIndex: 'receivingInfo', align: '', width: '', ellipsis: true },
        { title: '订单状态', dataIndex: 'status', align: '', width: '', scopedSlots: { customRender: 'status' } },
        { title: '操作', dataIndex: 'action', align: '', width: '', scopedSlots: { customRender: 'action' } }
      ],
      dataSource: [],
      searchParams: {
        phone: undefined,
        status: undefined,
        createTime: undefined,
        orderId: undefined
      },
      listApi: {
        url: '/pm/order/orderCheckList',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: '',
        addTitle: '',
        editTitle: ''
      },
      deleteParam: {
        url: '',
        title: '',
        key: '',
        resHandle: '' // 执行完删除的回调方法
      }
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    getSelect () {
    },
    /** 打开订单审核弹窗 */
    orderAudit (row) {
      this.visible = true;
      this.$nextTick(() => {
        this.orderId = row.orderId;
      });
    },
    /** 提交前处理事件 */
    reqHandle (params) {
      this.$put({
        url: '/pm/order/checkOrder',
        params: {
          orderId: this.orderId,
          ...params
        }
      }).then(({ data }) => {
        this.$message.success('审核成功');
        this.visible = false;
        this.$refs.table.getTableList();
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>

<style scoped lang="scss">
.product-name {
  display: flex;
  align-items: center;
  img {
    height: 44px;
  }
  span {
    margin-left: 10px;
  }
}
</style>
